// LOCATION: admin-portal/src/firebase.js

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC84q5ieIkBdzriv2rz7Kk6x4aqePvnedA",
  authDomain: "ccuringapp-633a5.firebaseapp.com",
  projectId: "ccuringapp-633a5",
  storageBucket: "ccuringapp-633a5.firebasestorage.app",
  messagingSenderId: "86991515820",
  appId: "1:86991515820:web:3f84e2c345d0c4d9dbaf09",
  measurementId: "G-2QHBDVFQMW"
};

// 1. Initialize Firebase
const app = initializeApp(firebaseConfig);

// 2. Initialize Services
const db = getFirestore(app);
const auth = getAuth(app);

// 3. Export them correctly (Once)
export { db, auth };

console.log("Firebase Initialized Successfully");